<div class="login_page-container">
  <app-login-layout
    [usuarioTipo]="usuarioTipo"
    [errorMessage]="errorMessage"
    (onSubmit)="handleLogin($event)"
  ></app-login-layout>
</div>
